<template>
  <div class="app-container">
    <!-- Sidebar: Hide if route.meta.hideSidebar is true -->
    <sideMenuBar v-if="!$route.meta.hideSidebar" class="sidebar" />

    <!-- Main Content -->
    <div :class="{'full-width': $route.meta.hideSidebar, 'content': !$route.meta.hideSidebar}">
      <router-view />
    </div>
  </div>
</template>

<script>
import sideMenuBar from "./components/sideMenu/sideMenuBar.vue";  // Ensure exact filename match

export default {
  name: "App",
  components: {
    sideMenuBar,  // Use the same name as the import
  }
};
</script>

<style scoped>
/* Add any styles if needed */
</style>
